/*
 * サイズ診断アシスタント
 * - <size-assistant> : 商品詳細ページのサイズ診断ボタン＋ボトムシート
 * - <size-finder>    : 「あなたのサイズで探す」ページ
 * 判定はすべてブラウザ内で完結する。寸法は localStorage にのみ保存（同意設定を有効にした場合のみ、
 * ご注文時に行プロパティ _体型データ として付与）。
 */
(function () {
  'use strict';
  if (window.LurcoSize) return;

  /* ===================== 定数 ===================== */
  var LS_KEY = 'lurco_size_profile';
  var LS_AB = 'lurco_size_ab';
  var LABEL = { bust: 'バスト', waist: 'ウエスト', hip: 'ヒップ', length: '着丈' };
  var JA_KEY = { 'バスト': 'bust', 'ウエスト': 'waist', 'ヒップ': 'hip' };
  var JA_STRETCH = { 'なし': 'none', 'ややあり': 'slight', 'あり': 'yes' };
  var STRETCH_LABEL = { none: 'なし', slight: 'ややあり', yes: 'あり' };
  /* 初期値の目安 [最低ゆとり, 適正上限]。型ごとに chart.ease で上書きできる */
  /* 比較の仕方（商品ページ記載）: バスト・ヒップ +6〜12cm、ウエスト +2〜6cm。
     この範囲に入るものを「丁度（適度）」とし、上限を超えたものを「大きめ」とする */
  var EASE = {
    none: { bust: [6, 12], waist: [2, 6], hip: [6, 12] },
    slight: { bust: [6, 12], waist: [2, 6], hip: [6, 12] },
    yes: { bust: [6, 12], waist: [2, 6], hip: [6, 12] },
  };
  var AUDIENCE_NOTE = '本サイズ診断は、成人女性のお客さま向けです。子ども服・男性服のサイズには対応しておりません。';
  var PREF_ADJ = { slim: -1, std: 0, loose: 3 };
  var PREF_LABEL = { slim: 'すっきり', std: '標準', loose: 'ゆったり' };
  var LEN_LABEL = { short: '短め', std: '標準', long: '長め' };
  var LEN_TARGET = { short: 5, std: 15, long: 25 }; // 希望する「膝下」の目安(cm)
  var LEN_HINT = {
    short: '膝が隠れる程度の、すっきりした丈（膝下 約5cm）',
    std: '膝下 約15cm のバランスの良い丈',
    long: '膝下をしっかり覆う、落ち着いた丈（膝下 約25cm）',
  };
  var STD_BODY = {
    '7号': { bust: 79, waist: 61, hip: 87 },
    '9号': { bust: 83, waist: 64, hip: 91 },
    '11号': { bust: 87, waist: 67, hip: 95 },
    '13号': { bust: 91, waist: 70, hip: 99 },
    '15号': { bust: 95, waist: 73, hip: 103 },
    '17号': { bust: 99, waist: 76, hip: 107 },
  };
  var RANGE = { bust: [70, 130], waist: [50, 120], hip: [75, 130] };
  var DEFAULT_START = { bust: 82, waist: 64, hip: 90 };
  var HOW = {
    bust: 'ブラを着用し、バストの一番高い位置を水平に。',
    waist: '胴の一番細い部分を水平に。息を吐いて自然に。',
    hip: 'お尻の一番高い位置を水平に。',
  };
  var PEER_MIN = 20; // 同じ体型の実績を表示する最小件数

  /* ===================== ユーティリティ ===================== */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(n) { return (n > 0 ? '＋' : n < 0 ? '−' : '') + Math.abs(Math.round(n * 10) / 10); }
  function num(sz) { return parseInt(sz, 10) || 0; }
  function bin3(v) { return Math.floor(v / 3) * 3; }
  /* オプション値からサイズ名を取り出す。「9号」形式を優先し、
     keys（サイズ表のサイズ名）が渡されたときは M / L / LL のような表記にも一致させる */
  function sizeOfText(text, keys) {
    var str = String(text || '');
    var m = /(\d+)\s*号/.exec(str);
    if (m) return m[1] + '号';
    if (keys) {
      var tokens = str.split(/[／\/_\s]+/);
      for (var i = 0; i < tokens.length; i++) { if (keys.indexOf(tokens[i]) !== -1) return tokens[i]; }
    }
    return null;
  }
  function sizeOfVariant(v, keys) {
    var opts = v.options || [];
    for (var i = 0; i < opts.length; i++) { var s = sizeOfText(opts[i], keys); if (s) return s; }
    return sizeOfText(v.title, keys);
  }
  var LETTER_RANK = ['XS', 'S', 'M', 'L', 'LL', 'XL', '2L', '3L', '4L', '5L', 'F', 'FREE', 'Free'];
  /* サイズ名の並び順：号数は数値順、M/L等は小さい順、それ以外は登録順 */
  function sortSizeKeys(keys) {
    var idx = {}; keys.forEach(function (k, i) { idx[k] = i; });
    return keys.slice().sort(function (a, b) {
      var na = num(a), nb = num(b);
      if (na && nb) return na - nb;
      var ra = LETTER_RANK.indexOf(a), rb = LETTER_RANK.indexOf(b);
      if (ra !== -1 && rb !== -1) return ra - rb;
      return idx[a] - idx[b];
    });
  }
  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* 画面下に短いお知らせを出す */
  function notice(msg) {
    var t = document.querySelector('.sa-toast');
    if (!t) { t = document.createElement('div'); t.className = 'sa-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(notice._t); notice._t = setTimeout(function () { t.classList.remove('is-on'); }, 3000);
  }

  /* ===================== イベント計測 ===================== */
  /* 寸法の生値は送らない。サイズ帯・モードなどの集計用の値のみ */
  function track(name, data) {
    data = data || {};
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data));
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('lurco:size', { detail: { name: name, data: data } })); } catch (e) {}
  }

  /* ===================== 型（サイズ表）の正規化 ===================== */
  function normChart(raw) {
    if (!raw || !raw.sizes) return null;
    var stretch = JA_STRETCH[raw.stretch] || raw.stretch || 'none';
    if (!EASE[stretch]) stretch = 'none';
    var key = (raw.key || []).map(function (k) { return JA_KEY[k] || k; }).filter(function (k) { return k === 'bust' || k === 'waist' || k === 'hip'; });
    if (!key.length) key = ['bust', 'hip'];
    var sizes = {};
    sortSizeKeys(Object.keys(raw.sizes)).forEach(function (k) {
      var sz = sizeOfText(k) || k;
      sizes[sz] = raw.sizes[k];
    });
    return {
      name: raw.name || '',
      stretch: stretch,
      silhouette: raw.silhouette || '',
      key: key,
      lengthBasis: !!raw.length_basis,
      lengthAdjust: raw.length_adjust || null,
      ease: raw.ease || null,
      peer: raw.peer || null,
      sizes: sizes,
    };
  }

  /* 丈違いの補正（選択中オプションの文字列に key が含まれていれば加算） */
  function sizesWithAdjust(chart, optionText) {
    if (!chart.lengthAdjust || !optionText) return chart.sizes;
    var add = 0;
    Object.keys(chart.lengthAdjust).forEach(function (k) { if (optionText.indexOf(k) !== -1) add += Number(chart.lengthAdjust[k]) || 0; });
    if (!add) return chart.sizes;
    var out = {};
    Object.keys(chart.sizes).forEach(function (sz) {
      out[sz] = Object.assign({}, chart.sizes[sz]);
      if (out[sz].length != null) out[sz].length += add;
    });
    return out;
  }

  /* ===================== 判定ロジック ===================== */
  /* allowed: 販売サイズ（変種が存在するサイズ）の配列。省略時は表の全サイズ */
  function evaluate(chart, body, pref, allowed) {
    var ease = {};
    ['bust', 'waist', 'hip'].forEach(function (k) {
      ease[k] = (chart.ease && chart.ease[k]) || EASE[chart.stretch][k];
    });
    var adj = PREF_ADJ[pref] != null ? PREF_ADJ[pref] : 0;
    var sizes = chart.sizes;
    var names = Object.keys(sizes).filter(function (n) { return !allowed || allowed.indexOf(n) !== -1; });
    if (!names.length) return null;
    var rows = names.map(function (sz) {
      var parts = chart.key.map(function (k) {
        var mn = ease[k][0] + adj, mx = ease[k][1] + adj;
        var lo = sizes[sz][k] - body[k], hi = lo;
        if (k === 'waist' && sizes[sz].waist_min != null) {
          /* ゴム仕様：範囲（下限〜上限）で判定。範囲が基準に重なれば丁度 */
          lo = sizes[sz].waist_min - body[k];
          hi = sizes[sz][k] - body[k];
        }
        return { k: k, e: hi, lo: lo, hi: hi, mn: mn, mx: mx, short: Math.max(0, mn - hi) };
      });
      return {
        sz: sz,
        parts: parts,
        fit: parts.every(function (x) { return x.short === 0; }),
        worstShort: Math.max.apply(null, parts.map(function (x) { return x.short; })),
        margin: Math.min.apply(null, parts.map(function (x) { return x.e - x.mn; })),
      };
    });
    var idx = -1;
    for (var i = 0; i < rows.length; i++) { if (rows[i].fit) { idx = i; break; } }
    var out = false;
    if (idx < 0) { idx = rows.length - 1; out = true; }
    var rec = rows[idx], lower = rows[idx - 1], next = rows[idx + 1];
    var boundary = false, pair = null;
    if (!out) {
      if (lower && lower.worstShort <= 1.5) { boundary = true; pair = [lower.sz, rec.sz]; }
      else if (next && rec.margin < 1.5) { boundary = true; pair = [rec.sz, next.sz]; }
    }
    var oversize = !out && rec.parts.some(function (x) { return x.lo > x.mx; });
    return { rows: rows, rec: rec, boundary: boundary, pair: pair, out: out, oversize: oversize };
  }
  function grade(ev) { return ev.out ? 'out' : ev.boundary ? 'warn' : 'ok'; }
  function easeLabel(x) {
    var txt = x.lo !== x.hi ? fmt(x.lo) + '〜' + fmt(x.hi) + 'cm' : fmt(x.e) + 'cm';
    if (x.hi < x.mn) return { t: txt + ' 窮屈', c: 'ng' };
    if (x.lo > x.mx) return { t: txt + ' 大きめ', c: 'mid' };
    return { t: txt + ' 丁度', c: 'ok' };
  }
  function kneeInfo(sizes, sz, height) {
    if (!height || !sizes[sz] || sizes[sz].length == null) return null;
    var len = sizes[sz].length;
    return { d: len - height * 0.535, len: len }; // プラス＝膝下
  }
  function peerLookup(chart, body, rec) {
    if (!chart.peer) return null;
    var key = [bin3(body.bust), bin3(body.waist), bin3(body.hip)].join('-');
    var hit = chart.peer[key];
    var bins = { bust: [bin3(body.bust), bin3(body.bust) + 2], waist: [bin3(body.waist), bin3(body.waist) + 2], hip: [bin3(body.hip), bin3(body.hip) + 2] };
    if (!hit) return null;
    if (hit.n < PEER_MIN) return { low: true, n: hit.n, bins: bins };
    var dist = Object.keys(hit.dist || {}).map(function (sz) {
      return { sz: sz, pct: hit.dist[sz], ret: hit.ret && hit.ret[sz] != null ? hit.ret[sz] : null };
    }).filter(function (d) { return d.pct >= 5; }).sort(function (a, b) { return b.pct - a.pct; }).slice(0, 3);
    return { low: false, n: hit.n, bins: bins, dist: dist };
  }

  /* ===================== プロフィール（localStorage） ===================== */
  function blankProfile() {
    return { mode: 'full', pref: 'std', lenPref: 'std', concern: 'none', body: { bust: '', waist: '', hip: '' }, height: '', usual: '', consent: false };
  }
  var profile = (function () {
    var p = blankProfile();
    try {
      var s = JSON.parse(localStorage.getItem(LS_KEY));
      if (s && typeof s === 'object') { p = Object.assign(p, s); p.mode = 'full'; p.body = Object.assign({ bust: '', waist: '', hip: '' }, s.body || {}); }
    } catch (e) {}
    return p;
  })();
  function saveProfile() { try { localStorage.setItem(LS_KEY, JSON.stringify(profile)); } catch (e) {} notify(); }
  function clearProfile() { try { localStorage.removeItem(LS_KEY); } catch (e) {} profile = blankProfile(); notify(); }
  var listeners = [];
  function onProfileChange(fn) { listeners.push(fn); }
  function notify() { listeners.forEach(function (fn) { try { fn(); } catch (e) {} }); }
  /* 他タブ・他ページでの変更も反映 */
  window.addEventListener('storage', function (e) {
    if (e.key !== LS_KEY) return;
    try { var s = JSON.parse(e.newValue); profile = Object.assign(blankProfile(), s || {}); profile.body = Object.assign({ bust: '', waist: '', hip: '' }, (s && s.body) || {}); } catch (err) { profile = blankProfile(); }
    notify();
  });
  function getBody() {
    if (profile.mode === 'simple') {
      var b = STD_BODY[profile.usual];
      if (!b) return null;
      var r = Object.assign({}, b);
      if (profile.concern && profile.concern !== 'none') r[profile.concern] += 3;
      return r;
    }
    var out = {};
    var ks = ['bust', 'waist', 'hip'];
    for (var i = 0; i < ks.length; i++) {
      var k = ks[i], v = parseFloat(profile.body[k]);
      if (!(v >= RANGE[k][0] && v <= RANGE[k][1])) return null;
      out[k] = v;
    }
    return out;
  }
  function getHeight() { var h = parseFloat(profile.height); return h >= 130 && h <= 190 ? h : null; }
  function bodyProps() {
    var b = getBody();
    if (!profile.consent || !b) return {};
    var t = 'B' + b.bust + '/W' + b.waist + '/H' + b.hip;
    if (getHeight()) t += '/身長' + getHeight();
    if (profile.mode === 'simple') t += '（推定）';
    return { '_体型データ': t, '_同意': 'true' };
  }

  /* ===================== カート追加 ===================== */
  function addItems(items) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { throw new Error(res.description || res.message || 'cart error'); }
        if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return res; }
        var first = res.items && res.items[0];
        var state = Object.assign({}, res, { key: first ? first.key : undefined, id: first ? first.id : undefined });
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(state);
        return res;
      });
  }

  /* ===================== ボトムシート ===================== */
  var Sheet = (function () {
    var root, ctx = null, built = false, lastFocus = null;
    var local; // 入力中の一時状態（実行時に profile へ反映）

    function build() {
      if (built) return;
      built = true;
      root = document.createElement('div');
      root.className = 'sa';
      root.innerHTML =
        '<div class="sa-overlay" data-sa-close></div>' +
        '<div class="sa-sheet" role="dialog" aria-modal="true" aria-labelledby="sa-title" tabindex="-1">' +
        '<div class="sa-sheet__hd"><h2 class="sa-sheet__title" id="sa-title"></h2><button type="button" class="sa-x" data-sa-close aria-label="閉じる">×</button></div>' +
        '<div class="sa-view" data-view="input"><div class="sa-sheet__body" data-body="input"></div><div class="sa-sheet__ft"><button type="button" class="button sa-btn" data-act="run" disabled>診断する</button></div></div>' +
        '<div class="sa-view" data-view="result" hidden><div class="sa-sheet__body" data-body="result"></div><div class="sa-sheet__ft" data-ft="result"></div></div>' +
        '</div>';
      document.body.appendChild(root);
      root.addEventListener('click', function (e) { if (e.target.closest('[data-sa-close]')) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
    }
    function isOpen() { return root && root.classList.contains('is-open'); }
    /* 計測位置を示す、シンプルな女性の正面イラスト（画像が無いときに使う） */
    function figure(k) {
      var img = ctx && ctx.images && ctx.images[k];
      var y = { bust: 66, waist: 100, hip: 136 }[k];
      var svg = '<svg class="sa-fig" viewBox="0 0 120 200" aria-hidden="true">' +
        '<circle class="sa-fig__h" cx="60" cy="22" r="12"/>' +
        '<path class="sa-fig__b" d="M50 40 Q60 36 70 40 L84 48 Q92 56 88 70 Q86 90 80 100 Q82 120 90 136 Q96 150 92 196 L28 196 Q24 150 30 136 Q38 120 40 100 Q34 90 32 70 Q28 56 36 48 Z"/>' +
        '<line class="sa-fig__l" x1="22" x2="98" y1="' + y + '" y2="' + y + '"/>' +
        '<circle class="sa-fig__dot" cx="22" cy="' + y + '" r="2.6"/><circle class="sa-fig__dot" cx="98" cy="' + y + '" r="2.6"/>' +
        '<text class="sa-fig__t" x="60" y="' + (y - 5) + '" text-anchor="middle">' + LABEL[k] + '</text></svg>';
      if (!img) return '<span class="sa-fig-wrap">' + svg + '</span>';
      return '<span class="sa-fig-wrap"><img class="sa-fig" src="' + esc(img) + '" alt="" onerror="this.closest(\'.sa-fig-wrap\').classList.add(\'no-img\')">' + svg + '</span>';
    }

    /* ---------- 入力画面 ---------- */
    function normNum(v) {
      return String(v).replace(/[０-９．]/g, function (c) { return c === '．' ? '.' : String.fromCharCode(c.charCodeAt(0) - 65248); });
    }
    function fieldHtml(k) {
      return '<div class="sa-fld" data-k="' + k + '">' + figure(k) + '<div class="sa-fld__main">' +
        '<div class="sa-fld__top"><span class="sa-fld__name">' + LABEL[k] + '<em>必須</em></span><span class="sa-fld__val" data-val="' + k + '"></span></div>' +
        '<div class="sa-fld__how">' + HOW[k] + '</div>' +
        '<div class="sa-stp" data-stp="' + k + '"><button type="button" data-d="-1" aria-label="' + LABEL[k] + 'を減らす">−</button>' +
        '<input inputmode="decimal" autocomplete="off" placeholder="例：' + DEFAULT_START[k] + '" value="' + esc(local.body[k]) + '" aria-label="' + LABEL[k] + '（cm）">' +
        '<button type="button" data-d="1" aria-label="' + LABEL[k] + 'を増やす">＋</button><span class="sa-stp__u">cm</span></div>' +
        '<div class="sa-sld" data-sld="' + k + '"><input type="range" min="' + RANGE[k][0] + '" max="' + RANGE[k][1] + '" step="1" aria-label="' + LABEL[k] + '（スライダー）">' +
        '<div class="sa-sld__cap"><span>' + RANGE[k][0] + '</span><span>スライドで調整</span><span>' + RANGE[k][1] + '</span></div></div>' +
        '<div class="sa-err" data-err="' + k + '"></div></div></div>';
    }
    function heightHtml() {
      return '<div class="sa-fld sa-fld--h" data-k="height"><div class="sa-fld__main sa-fld__main--full">' +
        '<div class="sa-fld__top"><span class="sa-fld__name">身長<em>必須</em></span><span class="sa-fld__val" data-val="height"></span></div>' +
        '<div class="sa-stp" data-hstp><button type="button" data-hd="-1" aria-label="身長を減らす">−</button>' +
        '<input inputmode="decimal" autocomplete="off" placeholder="例：158" value="' + esc(local.height) + '" aria-label="身長（cm）" data-f="height">' +
        '<button type="button" data-hd="1" aria-label="身長を増やす">＋</button><span class="sa-stp__u">cm</span></div>' +
        '<div class="sa-sld" data-hsld><input type="range" min="130" max="190" step="1" aria-label="身長（スライダー）">' +
        '<div class="sa-sld__cap"><span>130</span><span>スライドで調整</span><span>190</span></div></div>' +
        '<div class="sa-err" data-err="height"></div></div></div>';
    }
    function renderInput() {
      var bd = $('[data-body=input]', root);
      var finder = ctx.context === 'finder';
      var opts = Object.keys(STD_BODY).map(function (s) { return '<option value="' + s + '"' + (local.usual === s ? ' selected' : '') + '>' + s + '</option>'; }).join('');
      var consent = ctx.consent
        ? '<label class="sa-consent' + (local.consent ? ' is-on' : '') + '"><input type="checkbox" data-f="consent"' + (local.consent ? ' checked' : '') + '><span><b>寸法を購入データと一緒に保存することに同意する（任意）</b>' + esc(ctx.consentText) + '</span></label>'
        : '';
      bd.innerHTML =
        consent +
        '<div data-box="full"' + (local.mode === 'full' ? '' : ' hidden') + '>' + ['bust', 'waist', 'hip'].map(fieldHtml).join('') + '</div>' +
        /* 号数の簡易診断（一時停止中。復活時はこの部分を戻す）
        '<div data-box="simple"' + (local.mode === 'simple' ? '' : ' hidden') + '>' +
        '<p class="sa-note">寸法がわからない方向けの目安モードです。普段の号数から標準的な体型で推定するため、精度は寸法入力より低めになります。</p>' +
        '<div class="sa-sec">普段の号数</div><select class="sa-select" data-f="usual"><option value="">選択してください</option>' + opts + '</select>' +
        '<div class="sa-sec">気になる部位（任意）</div>' + seg('concern', [['none', '特になし'], ['bust', 'バスト'], ['waist', 'ウエスト'], ['hip', 'ヒップ']], local.concern) + '</div>' +
        */
        heightHtml() +
        /* 丈の好み（ロング丈などの商品があるため一時停止中。復活時はこの部分を戻す）
        '<div class="sa-lenpref"' + (finder || ctx.lengthBasis ? '' : ' hidden') + '><div class="sa-sec">丈の好み</div>' + seg('lenPref', [['short', '短め'], ['std', '標準'], ['long', '長め']], local.lenPref) +
        '<div class="sa-how" data-lenhint>' + LEN_HINT[local.lenPref] + '</div></div>' +
        */
        '<div class="sa-sec">着心地の好み</div>' + seg('pref', [['slim', 'すっきり'], ['std', '標準'], ['loose', 'ゆったり']], local.pref) +
        '<p class="sa-audience">' + AUDIENCE_NOTE + '</p>';
      bindInput(bd);
      paintAll();
      paintHeight();
      validate();
      $('[data-act=run]', root).textContent = finder ? '登録して一覧を見る' : '診断する';
    }
    function seg(name, items, cur) {
      return '<div class="sa-seg" data-seg="' + name + '">' + items.map(function (it) {
        return '<button type="button" data-v="' + it[0] + '" aria-pressed="' + (cur === it[0]) + '">' + it[1] + '</button>';
      }).join('') + '</div>';
    }
    function setVal(k, text) {
      var el = $('[data-val=' + k + ']', root);
      if (!el) return;
      el.textContent = text;
      el.classList.toggle('is-empty', text === '未入力');
    }
    function focusField(k) {
      $$('.sa-fld', root).forEach(function (f) { f.classList.toggle('is-active', f.dataset.k === k); });
    }
    function paint(k) {
      var w = $('[data-sld=' + k + ']', root), rng = $('input', w), v = parseFloat(local.body[k]);
      var ok = v >= RANGE[k][0] && v <= RANGE[k][1];
      w.classList.toggle('is-untouched', !ok);
      rng.value = ok ? v : DEFAULT_START[k];
      w.style.setProperty('--sa-p', ((rng.value - RANGE[k][0]) / (RANGE[k][1] - RANGE[k][0]) * 100) + '%');
      setVal(k, ok ? v + ' cm' : '未入力');
    }
    function paintAll() { ['bust', 'waist', 'hip'].forEach(function (k) { paint(k); }); }
    function paintHeight() {
      var w = $('[data-hsld]', root), rng = $('input', w), h = parseFloat(local.height), ok = h >= 130 && h <= 190;
      w.classList.toggle('is-untouched', !ok);
      rng.value = ok ? h : 158;
      w.style.setProperty('--sa-p', ((rng.value - 130) / 60 * 100) + '%');
      setVal('height', ok ? h + ' cm' : '未入力');
    }
    function validate() {
      var ok = true;
      if (local.mode === 'full') {
        ['bust', 'waist', 'hip'].forEach(function (k) {
          var raw = local.body[k], v = parseFloat(raw), r = RANGE[k];
          var bad = raw !== '' && !(v >= r[0] && v <= r[1]);
          $('[data-stp=' + k + ']', root).classList.toggle('is-err', bad);
          $('[data-err=' + k + ']', root).textContent = bad ? r[0] + '〜' + r[1] + 'cm の範囲で入力してください' : '';
          if (raw === '' || bad) ok = false;
        });
      } else { ok = !!local.usual; }
      var hraw = local.height, hv = parseFloat(hraw), hbad = hraw !== '' && !(hv >= 130 && hv <= 190);
      $('[data-hstp]', root).classList.toggle('is-err', hbad);
      $('[data-err=height]', root).textContent = hbad ? '130〜190cm の範囲で入力してください' : '';
      if (!(hv >= 130 && hv <= 190)) ok = false;
      $('[data-act=run]', root).disabled = !ok;
    }
    function bindInput(bd) {
      $$('.sa-modes button', bd).forEach(function (b) { b.onclick = function () { local.mode = b.dataset.mode; renderInput(); }; });
      $$('[data-stp]', bd).forEach(function (w) {
        var k = w.dataset.stp, inp = $('input', w), rng = $('[data-sld=' + k + '] input', bd);
        function set(v) { local.body[k] = v; inp.value = v; paint(k); validate(); }
        $$('button', w).forEach(function (b) {
          b.onclick = function () {
            var cur = parseFloat(inp.value), base = isNaN(cur) ? DEFAULT_START[k] : cur + Number(b.dataset.d);
            set(String(Math.max(RANGE[k][0], Math.min(RANGE[k][1], base))));
          };
        });
        inp.oninput = function () { local.body[k] = normNum(inp.value); paint(k); validate(); };
        inp.onfocus = function () { focusField(k); };
        rng.oninput = function () { set(rng.value); focusField(k); };
      });
      var hw = $('[data-hstp]', bd), hi = $('input', hw), hr = $('[data-hsld] input', bd);
      function setH(v) { local.height = v; hi.value = v; paintHeight(); validate(); }
      $$('button', hw).forEach(function (b) {
        b.onclick = function () {
          var cur = parseFloat(hi.value), base = isNaN(cur) ? 158 : cur + Number(b.dataset.hd);
          setH(String(Math.max(130, Math.min(190, base))));
        };
      });
      hi.oninput = function () { local.height = normNum(hi.value); paintHeight(); validate(); };
      hi.onfocus = function () { focusField('height'); };
      hr.oninput = function () { setH(hr.value); };
      $$('.sa-seg', bd).forEach(function (sg) {
        $$('button', sg).forEach(function (b) {
          b.onclick = function () {
            local[sg.dataset.seg] = b.dataset.v;
            $$('button', sg).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
            if (sg.dataset.seg === 'lenPref') $('[data-lenhint]', bd).textContent = LEN_HINT[local.lenPref];
          };
        });
      });
      var u = $('[data-f=usual]', bd); if (u) u.onchange = function () { local.usual = u.value; validate(); };
      var c = $('[data-f=consent]', bd);
      if (c) c.onchange = function () { local.consent = c.checked; track('size_data_consent', { consent: local.consent }); renderInput(); };
    }
    function run() {
      Object.assign(profile, local);
      profile.body = Object.assign({}, local.body);
      saveProfile();
      if (ctx.context === 'finder') {
        track('size_finder_complete', { mode: profile.mode, pref: profile.pref, lenPref: profile.lenPref });
        close();
        if (ctx.onDone) ctx.onDone();
        return;
      }
      showView('result');
      var ev = ctx.evaluate();
      track('size_assist_complete', { mode: profile.mode, pref: profile.pref, lenPref: profile.lenPref, recommended: ev ? (ev.out ? 'out' : ev.rec.sz) : null, boundary: ev ? ev.boundary : null });
    }

    /* ---------- 結果画面 ---------- */
    function statusWord(x) {
      if (x.hi < x.mn) return '窮屈';
      if (x.lo > x.mx) return '大きめ';
      return '丁度';
    }
    function renderResult() {
      var ev = ctx.evaluate(), body = getBody();
      if (!ev || !body) { showView('input'); return; }
      var rec = ev.rec, sizes = ctx.sizes(), h = getHeight();
      var desc;
      if (ev.out) desc = '最大サイズでも、ゆとりが不足する部位があります。';
      else if (ev.boundary) desc = ev.pair[0] + ' と ' + ev.pair[1] + ' のどちらも近い寸法です。';
      else if (ev.oversize) desc = '最も近いサイズですが、一部の部位でゆとりが大きめです。';
      else desc = 'ご入力の寸法に最も近いサイズです。';
      var title = ev.out ? '展開外' : (ev.boundary ? ev.pair.join(' ・ ') : rec.sz);
      var cmp = '';
      if (!ev.out) {
        var cols = ev.boundary ? ev.pair : [rec.sz];
        var head = '<tr><th>部位</th><th>A（ヌード寸法）</th>' + cols.map(function (sz) { return '<th>B（' + sz + '・仕上がり）</th><th>差（B−A）</th>'; }).join('') + '</tr>';
        var bodyRows = ['bust', 'waist', 'hip'].filter(function (k) {
          return cols.some(function (sz) { return sizes[sz][k] != null; });
        }).map(function (k) {
          var cells = cols.map(function (sz) {
            var v = sizes[sz][k], diff = v - body[k], prod = v + 'cm', txt = fmt(diff) + 'cm';
            var r = ev.rows.filter(function (x) { return x.sz === sz; })[0];
            var x = r ? r.parts.filter(function (p) { return p.k === k; })[0] : null;
            var status = x ? statusWord(x) : '参考';
            if (k === 'waist' && sizes[sz].waist_min != null) {
              prod = sizes[sz].waist_min + '〜' + v + 'cm';
              txt = fmt(sizes[sz].waist_min - body[k]) + '〜' + fmt(diff) + 'cm';
            }
            return '<td>' + prod + '</td><td><b>' + txt + '</b><small>' + status + '</small></td>';
          }).join('');
          return '<tr><th>' + LABEL[k] + '</th><td>' + body[k] + 'cm</td>' + cells + '</tr>';
        }).join('');
        cmp = '<table class="sa-cmp' + (cols.length > 1 ? ' sa-cmp--2' : '') + '"><thead>' + head + '</thead><tbody>' + bodyRows + '</tbody></table>';
      }

      var lengthHtml = '';
      /* 丈の案内（ロング丈などの商品があるため一時停止中。復活時はこの部分を戻す）
      if (ctx.lengthBasis) {
        var h = getHeight();
        if (h) {
          var k = kneeInfo(sizes, rec.sz, h);
          if (k) {
            var d = Math.round(Math.abs(k.d));
            var diff = Math.round(k.d - LEN_TARGET[profile.lenPref]);
            var near = Math.abs(diff) <= 4;
            var fit = near ? 'ご希望の「' + LEN_LABEL[profile.lenPref] + '」に近い丈です'
              : (diff < 0 ? 'ご希望の「' + LEN_LABEL[profile.lenPref] + '」より約' + (-diff) + 'cm 短めです' : 'ご希望の「' + LEN_LABEL[profile.lenPref] + '」より約' + diff + 'cm 長めです');
            lengthHtml = '<div class="sa-part"><div class="sa-part__hd"><b>丈の目安</b><span class="sa-val sa-val--' + (k.d >= 0 ? 'ok' : 'mid') + '">' + (k.d >= 0 ? '膝下 約' + d + 'cm' : '膝上 約' + d + 'cm') + '</span></div>' +
              '<div class="sa-part__hd sa-part__hd--sub"><span class="sa-how">丈の好み：' + LEN_LABEL[profile.lenPref] + '</span><span class="sa-val sa-val--' + (near ? 'ok' : 'mid') + '">' + fit + '</span></div>' +
              '<div class="sa-how">身長' + h + 'cm・着丈' + k.len + 'cm → ' + (k.d >= 0 ? '膝がしっかり隠れる丈です' : '膝が少し見える丈です。法事・葬儀では丈にご注意ください') + '。' +
              (!near ? '<br>丈違いの商品もあわせてご検討ください。' : '') + '</div></div>';
          }
        } else {
          lengthHtml = '<div class="sa-note">身長を入力すると、膝に対する丈の目安もご覧いただけます。<button type="button" class="sa-link" data-act="addheight">身長を入力する</button></div>';
        }
      }

      */

      var peerHtml = '';
      if (!ev.out) {
        var ps = peerLookup(ctx.chart, body, rec);
        if (ps) {
          var seg = 'バスト' + ps.bins.bust[0] + '〜' + ps.bins.bust[1] + '・ウエスト' + ps.bins.waist[0] + '〜' + ps.bins.waist[1] + '・ヒップ' + ps.bins.hip[0] + '〜' + ps.bins.hip[1] + 'cm';
          if (ps.low) {
            peerHtml = '<div class="sa-peer sa-peer--low"><h3>同じ体型の方の傾向</h3><p class="sa-peer__seg">' + seg + '</p><p class="sa-peer__sum">この体型帯の購入実績はまだ十分ではありません。上の診断結果をご参考ください。</p></div>';
          } else {
            var top = ps.dist[0];
            peerHtml = '<div class="sa-peer"><h3>同じ体型の方の傾向</h3><p class="sa-peer__seg">' + seg + '／ご協力いただいた ' + ps.n + '件の購入実績</p>' +
              ps.dist.map(function (d) { return '<div class="sa-peer__row' + (d.sz === rec.sz ? ' is-me' : '') + '"><span>' + d.sz + '</span><i class="sa-peer__bar"><b style="width:' + d.pct + '%"></b></i><span class="sa-peer__pct">' + d.pct + '%</span></div>'; }).join('') +
              '<p class="sa-peer__sum">同じ体型の方は <b>' + top.sz + '</b> を選ばれることが最も多く（' + top.pct + '%）' + (top.ret != null ? '、サイズ理由の返品は ' + top.ret + '% でした' : '') + '。</p></div>';
          }
        }
      }

      var tryon = '';
      /* 2サイズ試着の案内は一時停止中（復活時はこの分岐を戻す） */
      if (ev.out) {
        tryon = '<div class="sa-tryon"><h3>サイズのご相談</h3><p>この商品では最適なサイズをご案内できません。他の商品や、お問い合わせもご検討ください。</p></div>';
      }

      var modeNote = profile.mode === 'simple' ? '<div class="sa-note">号数からの簡易診断（目安）です。より正確な結果は、ヌード寸法の入力をおすすめします。</div>' : '';
      var prefNote = profile.pref !== 'std' ? '<div class="sa-note">着心地の好み「' + PREF_LABEL[profile.pref] + '」を反映しています。</div>' : '';

      $('[data-body=result]', root).innerHTML =
        '<div class="sa-hero">' + (ev.out ? '' : '<span class="sa-hero__label">おすすめサイズ</span>') +
        '<div class="sa-hero__size">' + esc(title) + '</div><p class="sa-hero__desc">' + desc + '</p></div>' + modeNote + prefNote +
        '<div class="sa-sec">ヌード寸法と商品サイズの比較</div>' + cmp + lengthHtml + peerHtml + tryon +
        '<p class="sa-alts">入力寸法：' + ['bust', 'waist', 'hip'].map(function (k) { return LABEL[k] + body[k] + 'cm'; }).join(' / ') + (profile.mode === 'simple' ? '（推定）' : '') + '</p>' +
        '<p class="sa-audience">' + AUDIENCE_NOTE + '</p>';

      $('[data-ft=result]', root).innerHTML =
        '<div class="sa-center"><button type="button" class="sa-btn-sub" data-act="edit">寸法を変更</button></div>' +
        '<div class="sa-center"><button type="button" class="sa-btn-sub" data-act="clear-profile">寸法をクリア</button></div>';
    }

    function showView(v) {
      $$('.sa-view', root).forEach(function (el) { el.hidden = el.dataset.view !== v; });
      $('#sa-title', root).textContent = v === 'input' ? (ctx.context === 'finder' ? 'あなたのサイズを入力' : 'あなたに合うサイズを診断') : '診断結果';
      if (v === 'input') {
        local = JSON.parse(JSON.stringify(profile));
        renderInput();
      } else { renderResult(); }
      $('.sa-sheet__body[data-body=' + v + ']', root).scrollTop = 0;
    }

    function open(c) {
      build();
      ctx = c;
      lastFocus = document.activeElement;
      root.onclick = function (e) {
        if (e.target.closest('[data-sa-close]')) { close(); return; }
        var a = e.target.closest('[data-act]');
        if (!a) return;
        var act = a.dataset.act;
        if (act === 'run') run();
        else if (act === 'edit') showView('input');
        else if (act === 'clear-profile') {
          /* 保存した寸法と診断の表示だけを消す。カートの行プロパティには触れない */
          clearProfile();
          close();
          notice('寸法をクリアしました');
        }
        else if (act === 'addheight') { showView('input'); setTimeout(function () { var h = $('[data-f=height]', root); if (h) h.focus(); }, 50); }
        else if (act === 'apply') { var sz = a.dataset.size; close(); ctx.onApply(sz); }
        else if (act === 'tryon') { var ev = ctx.evaluate(); if (ev && ev.pair) { close(); ctx.onTryon(ev.pair); } }
      };
      root.classList.add('is-open');
      document.documentElement.classList.add('sa-lock');
      showView(c.context === 'finder' ? 'input' : (getBody() && ctx.evaluate() ? 'result' : 'input'));
      var sheet = $('.sa-sheet', root); if (sheet) sheet.focus();
    }
    function close() {
      if (!root) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('sa-lock');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }
    return { open: open, close: close, isOpen: isOpen };
  })();

  /* ===================== A/Bテスト ===================== */
  function abGroup(ratio) {
    ratio = Number(ratio);
    if (!(ratio >= 0 && ratio < 100)) return 'show';
    var g = null;
    try { g = localStorage.getItem(LS_AB); } catch (e) {}
    if (g !== 'show' && g !== 'hide') {
      g = Math.random() * 100 < ratio ? 'show' : 'hide';
      try { localStorage.setItem(LS_AB, g); } catch (e) {}
    }
    return g;
  }

  /* ===================== 商品詳細ページ ===================== */
  class SizeAssistant extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.chart = normChart(parseJSON($('[data-sa-chart]', this)));
      this.images = parseJSON($('[data-sa-images]', this)) || {};
      this.variants = parseJSON($('[data-sa-variants]', this)) || [];
      if (!this.chart) { this.hidden = true; return; }
      this.cfg = {
        consent: this.dataset.consent === 'true',
        consentText: this.dataset.consentText || 'ご購入時に寸法がご注文情報へ付与され、サイズ提案の精度向上のための統計的な分析にのみ利用します。個人が特定できる形で表示することはありません。同意はいつでも撤回できます。',
        ticketId: this.dataset.ticketVariant || '',
        tryonUrl: this.dataset.tryonUrl || '/pages/guide-fitting',
      };
      if (abGroup(this.dataset.abRatio) === 'hide') { this.hidden = true; track('size_assist_ab', { group: 'control' }); return; }
      this.btn = $('[data-sa-open]', this);
      this.badge = $('[data-sa-badge]', this);
      this.main = $('[data-sa-main]', this);
      this.btn.addEventListener('click', this.open.bind(this));
      this.refresh = this.refresh.bind(this);
      onProfileChange(this.refresh);
      var info = this.closest('product-info') || document;
      this._mo = new MutationObserver(function () { clearTimeout(this._t); this._t = setTimeout(this.mark.bind(this), 60); }.bind(this));
      this._mo.observe(info, { childList: true, subtree: true });
      this.refresh();
      this.preselect();
    }
    disconnectedCallback() { if (this._mo) this._mo.disconnect(); }
    allowedSizes() {
      var s = [];
      var keys = Object.keys(this.chart.sizes);
      this.variants.forEach(function (v) { var z = sizeOfVariant(v, keys); if (z && s.indexOf(z) === -1) s.push(z); });
      return s;
    }
    selectedOptionText() {
      var form = this.closest('product-info') || document;
      var checked = $$('variant-selects input[type=radio]:checked', form).map(function (i) { return i.value; });
      var sels = $$('variant-selects select', form).map(function (s) { return s.value; });
      return checked.concat(sels).join(' ');
    }
    sizes() { return sizesWithAdjust(this.chart, this.selectedOptionText()); }
    evaluate() {
      var b = getBody();
      if (!b) return null;
      var c = Object.assign({}, this.chart, { sizes: this.sizes() });
      return evaluate(c, b, profile.pref, this.allowedSizes());
    }
    refresh() {
      var ev = this.evaluate();
      if (ev) {
        this.badge.hidden = false;
        this.badge.textContent = 'あなたのおすすめ：' + (ev.out ? '展開外' : ev.rec.sz);
        this.main.innerHTML = (ev.out ? 'サイズ展開外の可能性' : '診断結果を見る') + '';
      } else {
        this.badge.hidden = true;
        this.main.innerHTML = 'あなたに合うサイズを診断';
      }
      this.mark();
    }
    /* サイズ選択肢に「おすすめ」の印を付ける */
    mark() {
      var form = this.closest('product-info') || document;
      var ev = this.evaluate();
      $$('[data-sa-reco]', form).forEach(function (el) { el.removeAttribute('data-sa-reco'); });
      if (!ev || ev.out) return;
      /* 2サイズで迷うときは、両方に「おすすめ」を付ける */
      var marks = ev.boundary ? ev.pair : [ev.rec.sz], keys = Object.keys(this.chart.sizes);
      $$('variant-selects input[type=radio]', form).forEach(function (i) {
        if (marks.indexOf(sizeOfText(i.value, keys)) === -1) return;
        var lab = i.id ? $('label[for="' + i.id + '"]', form) : null;
        if (lab) lab.setAttribute('data-sa-reco', 'おすすめ');
      });
    }
    open() {
      var self = this;
      track('size_assist_open', { has_profile: !!getBody() });
      Sheet.open({
        context: 'pdp',
        chart: this.chart,
        images: this.images,
        consent: this.cfg.consent,
        consentText: this.cfg.consentText,
        lengthBasis: this.chart.lengthBasis,
        tryon: !!this.cfg.ticketId,
        tryonUrl: this.cfg.tryonUrl,
        sizes: function () { return self.sizes(); },
        evaluate: function () { return self.evaluate(); },
        onApply: function (sz) { self.applySize(sz); },
        onTryon: function (pair) { self.addTryon(pair); },
      });
    }
    /* バリアントピッカーにサイズをセット（他のオプションはそのまま） */
    applySize(sz, silent) {
      var form = this.closest('product-info') || document;
      var done = false, keys = Object.keys(this.chart.sizes);
      $$('variant-selects input[type=radio]', form).forEach(function (i) {
        if (done || sizeOfText(i.value, keys) !== sz || i.disabled) return;
        i.checked = true;
        i.dispatchEvent(new Event('change', { bubbles: true }));
        done = true;
      });
      if (!done) {
        $$('variant-selects select', form).forEach(function (s) {
          if (done) return;
          var o = $$('option', s).filter(function (op) { return sizeOfText(op.value, keys) === sz && !op.disabled; })[0];
          if (!o) return;
          s.value = o.value;
          s.dispatchEvent(new Event('change', { bubbles: true }));
          done = true;
        });
      }
      var ev = this.evaluate();
      if (!silent) track('size_assist_apply', { size: sz, recommended: ev ? ev.rec.sz : null, applied: done });
      if (!done && !silent) notice('このサイズは現在選択できません。');
      this.refresh();
    }
    /* 診断済みなら、おすすめサイズ（候補が2つなら小さい方）を選択しておく */
    preselect() {
      var self = this;
      setTimeout(function () {
        var ev = self.evaluate();
        if (!ev || ev.out || !getBody()) return;
        self.applySize(ev.rec.sz, true);
      }, 300);
    }
    /* 現在のその他オプションを保ったまま、指定サイズのバリアントIDを探す */
    variantIdFor(sz) {
      var cur = this.currentOptions();
      var best = null, keys = Object.keys(this.chart.sizes);
      this.variants.forEach(function (v) {
        if (sizeOfVariant(v, keys) !== sz || !v.available) return;
        var score = 0;
        (v.options || []).forEach(function (o, i) { if (cur[i] != null && cur[i] === o) score++; });
        if (!best || score > best.score) best = { id: v.id, score: score };
      });
      return best ? best.id : null;
    }
    currentOptions() {
      var form = this.closest('product-info') || document;
      var out = [];
      $$('variant-selects fieldset', form).forEach(function (fs, i) {
        var c = $('input[type=radio]:checked', fs); if (c) out[i] = c.value;
      });
      $$('variant-selects select', form).forEach(function (s, i) { out[i] = s.value; });
      return out;
    }
    addTryon(pair) {
      var self = this;
      var ids = pair.map(function (sz) { return self.variantIdFor(sz); });
      if (ids.some(function (x) { return !x; })) { notice('選択できる在庫がありません。サイズ表をご確認ください。'); return; }
      var ev = this.evaluate();
      var props = Object.assign({ '_試着サービス': 'true', '_診断利用': 'true', '_推奨サイズ': ev ? ev.rec.sz : '' }, bodyProps());
      var items = ids.map(function (id) { return { id: id, quantity: 1, properties: props }; });
      items.push({ id: Number(this.cfg.ticketId), quantity: 1 });
      track('tryon_select', { sizes: pair.join('/') });
      addItems(items).catch(function () { window.location = '/cart'; });
    }
  }
  if (!customElements.get('size-assistant')) customElements.define('size-assistant', SizeAssistant);

  /* 商品ページのカート追加フォームに診断情報を付与（hidden フィールド） */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var sa = document.querySelector('size-assistant');
    if (!sa || sa.hidden || !sa._init) return;
    var ev = sa.evaluate();
    var props = Object.assign({}, bodyProps());
    if (ev) { props['_診断利用'] = 'true'; props['_推奨サイズ'] = ev.out ? '展開外' : ev.rec.sz; }
    Object.keys(props).forEach(function (k) {
      var name = 'properties[' + k + ']';
      var inp = form.querySelector('input[name="' + name + '"]');
      if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = name; form.appendChild(inp); }
      inp.value = props[k];
    });
    track('add_to_cart', { source: 'pdp', assisted: !!ev });
  }, true);

  /* ===================== サイズで探すページ ===================== */
  class SizeFinder extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.endpoint = this.dataset.endpoint || '/collections/all';
      this.ticketId = this.dataset.ticketVariant || '';
      this.lowStock = Number(this.dataset.lowStock || 3);
      this.consent = this.dataset.consent === 'true';
      this.consentText = this.dataset.consentText || undefined;
      this.filters = { grade: 'okwarn', cat: 'all', stock: false };
      this.items = [];
      this.root = $('[data-sf-root]', this);
      this.grid = $('[data-sf-grid]', this);
      this.profileEl = $('[data-sf-profile]', this);
      this.countEl = $('[data-sf-count]', this);
      this.toastEl = $('[data-sf-toast]', this);
      this.images = parseJSON($('[data-sf-images]', this)) || {};
      this.bind();
      onProfileChange(this.render.bind(this));
      track('size_finder_view', { has_profile: !!getBody() });
      this.load();
    }
    bind() {
      var self = this;
      $$('[data-sf-seg]', this).forEach(function (sg) {
        $$('button', sg).forEach(function (b) {
          b.addEventListener('click', function () { self.filters[sg.dataset.sfSeg] = b.dataset.v; self.render(); });
        });
      });
      $$('[data-sf-toggle=stock]', this).forEach(function (tg) {
        tg.addEventListener('click', function () { self.filters.stock = !self.filters.stock; self.render(); });
      });
      this.addEventListener('click', function (e) {
        var th = e.target.closest('[data-sf-thumb]'); if (!th) return;
        e.preventDefault();
        var card = th.closest('.sf-card'), main = $('[data-sf-main]', card);
        if (main) main.src = th.dataset.src;
        $$('[data-sf-thumb]', card).forEach(function (x) { x.classList.toggle('is-on', x === th); });
      });
      this.addEventListener('click', function (e) {
        var t = e.target.closest('[data-act]'); if (!t) return;
        var a = t.dataset.act;
        if (a === 'edit') { track('size_finder_open_input'); self.openSheet(); }
        else if (a === 'clear') { if (window.confirm('保存した寸法を消去します。よろしいですか？')) clearProfile(); }
      });
      this.addEventListener('click', function (e) {
        var l = e.target.closest('[data-sf-link]');
        if (l) track('size_finder_click', { item: l.dataset.sfLink });
      });
    }
    openSheet() {
      var self = this;
      Sheet.open({ context: 'finder', images: this.images, consent: this.consent, consentText: this.consentText, onDone: function () { self.render(); self.toast('寸法を保存しました。商品ページでも同じ寸法が使われます'); } });
    }
    toast(msg) {
      var t = this.toastEl; if (!t) return;
      t.textContent = msg; t.classList.add('is-on');
      clearTimeout(this._tt); this._tt = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
    }
    /* コレクションのJSON（collection.size-json）を全ページ取得 */
    async load() {
      var self = this, page = 1, pages = 1, all = [];
      this.grid.innerHTML = '<p class="sf-msg">読み込み中…</p>';
      try {
        while (page <= pages && page <= 20) {
          var res = await fetch(this.endpoint + (this.endpoint.indexOf('?') === -1 ? '?' : '&') + 'view=size-json&page=' + page);
          var data = await res.json();
          pages = data.pages || 1;
          all = all.concat(data.items || []);
          page++;
        }
      } catch (e) {
        this.grid.innerHTML = '<p class="sf-msg">商品の読み込みに失敗しました。時間をおいて再度お試しください。</p>';
        return;
      }
      this.items = all.map(function (it) {
        it.chart = normChart(it.chart);
        var keys = it.chart ? Object.keys(it.chart.sizes) : null;
        it.variants.forEach(function (v) { v.size = sizeOfVariant(v, keys); });
        it.images = it.images || [];
        it.sizeList = [];
        it.variants.forEach(function (v) { if (v.size && it.sizeList.indexOf(v.size) === -1) it.sizeList.push(v.size); });
        it.sizeList = sortSizeKeys(it.sizeList);
        return it;
      });
      this.render();
    }
    stockOf(it, sz) {
      var vs = it.variants.filter(function (v) { return v.size === sz; });
      var avail = vs.filter(function (v) { return v.available; });
      var qty = null;
      avail.forEach(function (v) { if (v.qty != null) qty = (qty || 0) + v.qty; });
      return { ok: avail.length > 0, qty: avail.length && qty != null ? qty : null };
    }
    render() {
      var self = this, body = getBody(), h = getHeight();
      /* プロフィール欄 */
      var chips = [];
      if (body) {
        var est = profile.mode === 'simple' ? '（推定）' : '';
        if (profile.mode === 'simple') chips.push('普段 ' + profile.usual + (profile.concern !== 'none' ? '・' + LABEL[profile.concern] + 'が気になる' : ''));
        ['bust', 'waist', 'hip'].forEach(function (k) { chips.push(LABEL[k] + ' ' + body[k] + 'cm' + est); });
        if (h) chips.push('身長 ' + h + 'cm');
        chips.push('着心地：' + PREF_LABEL[profile.pref]);
        /* 丈：一時停止中 */
      }
      this.profileEl.innerHTML = body
        ? '<h3 class="sf-profile__ttl">あなたのヌード寸法</h3><div class="sf-chips">' + chips.map(function (c) { return '<span class="sf-chip">' + esc(c) + '</span>'; }).join('') + '</div>' +
          '<div class="sf-btns"><button type="button" class="sa-btn-sub" data-act="edit">寸法を変更</button><button type="button" class="sa-btn-sub" data-act="clear">保存した寸法を消去</button></div>'
        : '<div class="sf-empty"><button type="button" class="button" data-act="edit">サイズを入力して探す</button></div>';

      /* フィルタ表示 */
      $$('[data-sf-toggle=stock]', this).forEach(function (tg) { tg.setAttribute('aria-pressed', !!self.filters.stock); });
      $$('[data-sf-seg]', this).forEach(function (sg) {
        $$('button', sg).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.v === self.filters[sg.dataset.sfSeg]); });
      });

      var rows = this.items.filter(function (it) { return it.chart && it.sizeList.length; }).map(function (it) {
        var c = Object.assign({}, it.chart);
        return { it: it, ev: body ? evaluate(c, body, profile.pref, it.sizeList) : null };
      }).filter(function (r) { return self.filters.cat === 'all' || r.it.category === self.filters.cat; });
      var unsupported = this.items.filter(function (it) { return !it.chart; }).length;
      var outN = body ? rows.filter(function (r) { return r.ev && r.ev.out; }).length : 0;
      if (body) {
        var order = { ok: 0, warn: 1, out: 2 };
        rows = rows.filter(function (r) {
          if (!r.ev) return false;
          var g = grade(r.ev);
          if (self.filters.grade === 'ok' && g !== 'ok') return false;
          if (self.filters.grade === 'okwarn' && g === 'out') return false;
          if (self.filters.stock && (g === 'out' || !self.stockOf(r.it, r.ev.rec.sz).ok)) return false;
          return true;
        }).sort(function (a, b) { return order[grade(a.ev)] - order[grade(b.ev)]; });
      }
      this.countEl.innerHTML = body
        ? '<b>' + rows.length + '点</b>が見つかりました' + (outN && this.filters.grade !== 'all' ? '<span>（サイズ展開外 ' + outN + '点は除外）</span>' : '')
        : '全' + rows.length + '点　<span>サイズを入力すると、おすすめサイズ順に並びます</span>';

      this.grid.innerHTML = rows.map(function (r) { return self.card(r.it, r.ev, h); }).join('') ||
        '<p class="sf-msg">条件に合う商品がありません。判定の条件をゆるめてみてください。</p>';
      var note = $('[data-sf-note]', this);
      if (note) note.textContent = '';
    }
    card(it, ev, h) {
      var self = this;
      var imgs = (it.images && it.images.length ? it.images : (it.image ? [it.image] : [])).slice(0, 5);
      var img = imgs[0] ? '<img data-sf-main src="' + esc(imgs[0]) + '" alt="' + esc(it.title) + '" loading="lazy" width="480" height="640">' : '';
      var thumbs = imgs.length > 1 ? '<div class="sf-thumbs">' + imgs.map(function (u, i) {
        return '<button type="button" class="sf-thumb' + (i === 0 ? ' is-on' : '') + '" data-sf-thumb data-src="' + esc(u) + '" aria-label="画像' + (i + 1) + '"><img src="' + esc(u) + '" alt="" loading="lazy" width="120" height="160"></button>';
      }).join('') + '</div>' : '';
      var strip = it.sizeList.map(function (sz) {
        var cls = '';
        if (ev) {
          var r = ev.rows.filter(function (x) { return x.sz === sz; })[0];
          cls = ev.rec.sz === sz && !ev.out ? 'is-rec' : (ev.pair && ev.pair.indexOf(sz) !== -1) ? 'is-pair' : (r && r.fit) ? 'is-fit' : '';
        }
        var so = !self.stockOf(it, sz).ok ? ' is-so' : '';
        return '<span class="sf-sz ' + cls + so + '" title="' + esc(sz) + (so ? '（在庫なし）' : '') + '">' + esc(sz.replace('号', '')) + '</span>';
      }).join('');
      var head = '<a class="sf-card__img" href="' + esc(it.url) + '" data-sf-link="' + it.id + '">' + img + '</a>' + thumbs;
      if (!ev) {
        return '<article class="sf-card is-dim">' + head + '<div class="sf-card__body"><p class="sf-card__name">' + esc(it.title) + '</p><p class="sf-card__price">' + esc(it.price) + '</p><div class="sf-strip">' + strip + '</div>' +
          '<a class="sf-link" href="' + esc(it.url) + '" data-sf-link="' + it.id + '">詳しく見る</a></div></article>';
      }
      var g = grade(ev), rec = ev.rec;
      var bd = getBody();
      var meta = ev.out ? '最大サイズでもゆとりが不足する部位があります。' : 'ヌード寸法との差：' + ['bust', 'waist', 'hip'].filter(function (k) { return it.chart.sizes[rec.sz] && it.chart.sizes[rec.sz][k] != null && bd; }).map(function (k) { return LABEL[k] + fmt(it.chart.sizes[rec.sz][k] - bd[k]) + 'cm'; }).join(' / ');
      /* 丈の案内：一時停止中
      if (!ev.out && it.chart.lengthBasis && h) {
        var k = kneeInfo(it.chart.sizes, rec.sz, h);
        if (k) { var d = Math.round(Math.abs(k.d)); meta += '<br>丈：' + (k.d >= 0 ? '膝下約' + d + 'cm' : '膝上約' + d + 'cm'); }
      }
      */
      var stock = '';
      if (!ev.out) {
        var st = this.stockOf(it, rec.sz);
        stock = !st.ok ? '<p class="sf-stock is-no">' + esc(rec.sz) + 'は在庫なし' + (ev.pair && ev.pair.filter(function (x) { return x !== rec.sz && self.stockOf(it, x).ok; })[0] ? '（' + ev.pair.filter(function (x) { return x !== rec.sz; })[0] + 'は在庫あり）' : '') + '</p>'
          : (st.qty != null && st.qty <= this.lowStock) ? '<p class="sf-stock is-low">' + esc(rec.sz) + ' 残りわずか</p>' : '<p class="sf-stock is-ok">' + esc(rec.sz) + ' 在庫あり</p>';
      }
      return '<article class="sf-card' + (g === 'out' ? ' is-dim' : '') + '">' + head + '<div class="sf-card__body">' +
        '<p class="sf-card__name">' + esc(it.title) + '</p><p class="sf-card__price">' + esc(it.price) + '</p>' +
        '<p class="sf-rec">' + (ev.out ? 'おすすめなし' : 'おすすめ ' + esc(rec.sz)) + (g === 'warn' ? '<small>2サイズ試着OK</small>' : '') + '</p>' +
        '<div class="sf-strip">' + strip + '</div><p class="sf-meta">' + meta + '</p>' + stock +
        (ev.out ? '<p class="sf-stock is-no">ご案内できるサイズがありません</p>' : '') +
        '<a class="sf-link" href="' + esc(it.url) + '" data-sf-link="' + it.id + '">詳しく見る</a></div></article>';
    }
    itemById(id) { return this.items.filter(function (x) { return String(x.id) === String(id); })[0]; }
  }
  if (!customElements.get('size-finder')) customElements.define('size-finder', SizeFinder);

  window.LurcoSize = { evaluate: evaluate, getBody: getBody, profile: function () { return profile; }, clear: clearProfile };
})();
